/** Read primary key from API rows (PascalCase or camelCase). */
export const pickRecordId = (row, ...keys) => {
  if (!row || typeof row !== 'object') return null;
  for (const key of keys) {
    const value = row[key];
    if (value !== undefined && value !== null && value !== '') {
      const num = Number(value);
      if (Number.isFinite(num) && num > 0) return num;
    }
  }
  return null;
};

export const isRecordDeleted = (row) => {
  const flag = row?.IsDeleted ?? row?.isDeleted;
  return flag === true || flag === 1 || String(flag).toLowerCase() === 'true';
};

export const filterActiveRecords = (rows = []) =>
  (Array.isArray(rows) ? rows : []).filter((row) => !isRecordDeleted(row));
